'use client';

import classnames from 'classnames';
import { IImage } from '@sapientpro/sapientpro-data-models';
import Button, { ButtonVariants } from '../Button';
import AnimatedTitle from '../AnimatedTitle';
import styles from './CTA.module.scss';
import { SUPPORTED_VIDEO_EXTENSIONS } from '../../../constants';

type CTAData = {
  ctaButton: string;
  description: string;
  image?: IImage;
  imageSide: 'left' | 'right';
  media: IImage;
  route: string;
  title: string;
};

const CTA = ({
  data: {
    title, description, ctaButton, media, route, imageSide,
  },
  blockView,
}: { data: CTAData, blockView?: boolean }) => {
  const isReversed = imageSide === 'left';
  const isVideo = SUPPORTED_VIDEO_EXTENSIONS.includes(media.ext);

  const videoTypeSuffix = isVideo ? media?.ext?.slice(1) : '';

  return (
    <section className={classnames(styles.ctaSection, {
      container: !blockView,
    })}
    >
      <div
        className={classnames(styles.CTAContainer, {
          [styles.reversed]: isReversed,
          [styles.blockView]: blockView,
        })}
      >
        <div className={styles.titleAndButtonSection}>
          <h5 className={classnames(styles.CTATitle, 'header4')}>
            <AnimatedTitle title={title} />
          </h5>
          {description && (<div className={classnames(styles.CTADescription, 'bodySmall')}>{description}</div>)}
          <Button
            variant={ButtonVariants.PRIMARY}
            className={styles.CTAButton}
            link={route}
          >
            {ctaButton}
          </Button>
        </div>
        {isVideo ? (
          <video
            autoPlay
            loop
            muted
            className={styles.CTAVideo}
          >
            <source
              src={media.url}
              type={`video/${videoTypeSuffix}`}
            />
          </video>
        ) : (
          <div
            className={styles.imagePlace}
          >
            <img
              src={media?.url}
              alt='Article CTA'
              className={styles.CTAImage}
            />
          </div>
        )}
        <div className={styles.CTAEllipse} />
      </div>
    </section>

  );
};

export default CTA;
